import { useState } from "react";
import { toast } from "react-toastify";
import isEmail from "is-email/lib";
import emailService from "../../services/email.service";

function ContactFormWidget() {
  // set field value state
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // set error state
  const [nameErr, setNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [subjectErr, setSubjectErr] = useState(false);
  const [msgErr, setMsgErr] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // console.log("on form submit");

    // dismissing all error toast
    toast.dismiss();

    let errorCtr = 0;

    // disabled button to prevent multiple submission
    const submitBtn = document.querySelector("button[type=submit]");
    submitBtn.setAttribute("disabled", "");

    // form validation
    if (name.trim() === "") {
      toast.error("Name is required.");
      setNameErr(true);
      errorCtr++;
    }

    if (email.trim() === "") {
      toast.error("Email is required.");
      setEmailErr(true);
      errorCtr++;
    } else if (!isEmail(email)) {
      toast.error("Email format is invalid.");
      setEmailErr(true);
      errorCtr++;
    }

    if (subject.trim() === "") {
      toast.error("Subject is required.");
      setSubjectErr(true);
      errorCtr++;
    }

    if (message.trim() === "") {
      toast.error("Message is required.");
      setMsgErr(true);
      errorCtr++;
    }

    if (errorCtr > 0) {
      submitBtn.removeAttribute("disabled");
      return;
    }

    // reset error state
    setNameErr(false);
    setEmailErr(false);
    setSubjectErr(false);
    setMsgErr(false);

    // construct body request
    const reqBody = {
      name,
      email,
      subject,
      message,
    };

    // console.log("sending email");
    await emailService
      .sendEmail("contactus", reqBody)
      .then(() => {
        toast.success("Email sent!");
        submitBtn.removeAttribute("disabled");

        // reset field
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error("Error encountered. Please try again later.");
        submitBtn.removeAttribute("disabled");
      });
  };

  return (
    <div className="wow fadeInUp" data-wow-delay="0.5s">
      <p className="mb-4">
        In varius id sem ut ultrices. Fusce eu dignissim diam. Quisque malesuada
        eget ipsum vitae sagittis. Fusce tempor lectus pretium sagittis
        interdum. Nulla tincidunt sem risus, et pretium odio vehicula a.
        Vestibulum iaculis sapien lectus, eu euismod diam ornare ac. In hac
        habitasse platea dictumst.
      </p>
      <form onSubmit={handleFormSubmit} noValidate>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="text"
                className={`form-control ${nameErr ? "is-invalid" : ""}`}
                id="name"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label htmlFor="name">Your Name</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="email"
                className={`form-control ${emailErr ? "is-invalid" : ""}`}
                id="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="email">Your Email</label>
            </div>
          </div>
          <div className="col-12">
            <div className="form-floating">
              <input
                type="text"
                className={`form-control ${subjectErr ? "is-invalid" : ""}`}
                id="subject"
                placeholder="Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
              <label htmlFor="subject">Subject</label>
            </div>
          </div>
          <div className="col-12">
            <div className="form-floating">
              <textarea
                className={`form-control ${msgErr ? "is-invalid" : ""}`}
                placeholder="Leave a message here"
                id="message"
                style={style.msg}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <label htmlFor="message">Message</label>
            </div>
          </div>
          <div className="col-12">
            <button className="btn btn-primary w-100 py-3" type="submit">
              Send Message
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

const style = {
  msg: { height: "150px" },
};

export default ContactFormWidget;
